<template>


    <div class="container mt-5">

        <router-link class="btn-back" to="/"><i class="fas fa-long-arrow-alt-left"></i> Retourner à la page d'accueil</router-link>
        <div class="titleProduct"><img src="../assets/img/DigitAppro.png" class="img-fluid logoProd" alt="DigitAppro">{{ $t('digitappro') }}</div>
        <div class="subTitle">{{ $t('dap.headerTitle') }}</div>
        <div class="">{{ $t('dap.headerContent') }}</div> <br>

        
        <!-- <div class="col">
                <video src="https://d2xwffv7hmia2n.cloudfront.net/images/content/references/video/dap.mp4" autoplay controls></video>
            </div> -->


        <div class="highlighted"> 
            <i class="fas fa-network-wired blue"></i>
            {{ $t('dap.product.title') }}
        </div>
        <div class="row align-items-center">
            <div class="col-md-6">
                <div class="card-title">
                    {{ $t('dap.product.subTitle') }}
                </div>
                <p>{{ $t('dap.product.content1') }}</p>
                <p>{{ $t('dap.product.content2') }}</p>
                <p>{{ $t('dap.product.content3') }}</p>
            </div>
            <div class="col image" data-aos="zoom-in-left"  data-aos-duration="1000" ><img src="../assets/img/digitappro/search.png" class="img-fluid screenShot profiledRight" alt="DigitAppro" ></div>
        </div>


        <div class="highlighted"> 
            <i class="fas fa-warehouse blue"></i>
            {{ $t('dap.availability.title') }}
        </div>
        <div class="row align-items-center">
            <div class="col image"  data-aos="zoom-in-right"  data-aos-duration="1000"><img src="../assets/img/digitappro/dispoRealTime.png" class="img-fluid screenShot profiledLeft" alt="DigitAppro"></div>
            <div class="col-md-6">
                <div class="card-title">
                    {{ $t('dap.availability.subTitle') }}
                </div>
                <p>{{ $t('dap.availability.content1') }}</p>
                <p>{{ $t('dap.availability.content2') }}</p>
                <p>{{ $t('dap.availability.content3') }}</p>
            </div>
        </div>


        <div class="highlighted"> 
            <i class="fas fa-map-marked-alt blue"></i>
            {{ $t('dap.territory.title') }}
        </div>
        <div class="row align-items-center">
            <div class="col-md-6">
                <div class="card-title">
                    {{ $t('dap.territory.subTitle') }}
                </div>
                <p>{{ $t('dap.territory.content1') }}</p>
                <p>{{ $t('dap.territory.content2') }}</p>
                <p>{{ $t('dap.territory.content3') }}</p>
            </div>
            <div class="col image"  data-aos="zoom-in-left"  data-aos-duration="1000"><img src="../assets/img/digitappro/magasins.png" class="img-fluid screenShot profiledRight" alt="DigitAppro"></div>
        </div>



        <div class="highlighted"> 
            <i class="fas fa-shipping-fast blue"></i>
            {{ $t('dap.delivery.title') }}
        </div>
        <div class="row align-items-center">
            <div class="col image"  data-aos="zoom-in-right"  data-aos-duration="1000"><img src="../assets/img/digitappro/kpis.png" class="img-fluid screenShot profiledLeft" alt="DigitAppro"></div>
            <div class="col-md-6">
                <div class="card-title">
                    {{ $t('dap.delivery.subTitle') }}
                </div>
                <p>{{ $t('dap.delivery.content1') }}</p>
                <p>
                    {{ $t('dap.delivery.content2') }}
                    <ul>
                        <li> {{ $t('dap.delivery.line1') }} </li>
                        <li> {{ $t('dap.delivery.line2') }} </li>
                        <li> {{ $t('dap.delivery.line3') }} </li>
                    </ul>
                </p>
            </div>
        </div>

        <div id="last-anchor" class="highlighted"> 
            <i class="fas fa-balance-scale blue"></i>
            {{ $t('dap.logistic.title') }}
        </div>
        <div class="row align-items-center">
            <div class="col-md-6">
                <div class="card-title">
                    {{ $t('dap.logistic.subTitle') }}
                </div>
                <p>{{ $t('dap.logistic.content1') }}</p>
                <p>{{ $t('dap.logistic.content2') }}</p>
            </div>
            <div class="col image"  data-aos="zoom-in-left"  data-aos-duration="1000"><img src="../assets/img/digitappro/transport.png" class="img-fluid screenShot profiledRight" alt="DigitAppro" data-aos="fade-in-right" data-aos-anchor="#last-anchor" data-aos-offset="600" data-aos-duration="1000"></div>
        </div>



        <div class="highlighted"> 
            {{ $t('dap.data.title') }}
        </div>

        <div class="container">
            <div class="row align-items-center">
                <div class="col-md-6">

                    <div class="card"  data-aos="zoom-in-right"  data-aos-duration="1000">
                        <div class="card-title">
                            <i class="fas fa-database mr-3"></i> {{ $t('dap.data.subTitle1') }}
                        </div>
                        <div class="card-content">
                            <ul>
                                <li>{{ $t('dap.data.line11') }}</li>
                                <li>{{ $t('dap.data.line12') }}</li>
                                <li>{{ $t('dap.data.line13') }}</li>
                                <li>{{ $t('dap.data.line14') }}</li>
                            </ul>
                        </div>
                    </div>

                    <div class="card"  data-aos="zoom-in-right"  data-aos-duration="1200">
                        <div class="card-title">
                            <i class="fas fa-user-shield mr-3"></i> {{ $t('dap.data.subTitle2') }}
                        </div>
                        <div class="card-content">
                            <ul>
                                <li>{{ $t('dap.data.line21') }}</li>
                                <li>{{ $t('dap.data.line22') }}</li>
                                <li>{{ $t('dap.data.line23') }}</li>
                            </ul>
                        </div>
                    </div>

                        <div class="card"  data-aos="zoom-in-right"  data-aos-duration="1400">
                        <div class="card-title">
                            <i class="fas fa-lock mr-3"></i> {{ $t('dap.data.subTitle3') }}
                        </div>
                        <div class="card-content">
                            <ul>
                                <li>{{ $t('dap.data.line31') }}</li>
                                <li>{{ $t('dap.data.line32') }}</li>
                                <li>{{ $t('dap.data.line33') }}</li>
                            </ul>
                        </div>
                    </div>

                </div>
                <div class="col text-center">
                    <img src="@/assets/img/GDPR.png" class="img-fluid" alt="RGPD">
                    <router-link class="btn btn-primary ml-auto" to="/solutions/digitappro/rgpd"> {{ $t('dap.data.btnrgpd') }} </router-link>   
                    <router-link class="btn btn-primary mx-auto" to="/contact-demo"> {{ $t('dap.data.btndemo') }}</router-link>    
                </div>
            </div>
        </div>



        <div class="chart">

            <div class="highlighted mt-5"> {{ $t('dap.platform.title') }} </div>

            <div class="row">

            <div class="col chart-btn">
                    <div @mouseover="img1 = true, img0 = false" @mouseleave="img1 = false, img0 = true" class="card">
                        <div class="card-title">
                            <i class="fas fa-boxes mr-2"></i> {{ $t('dap.platform.product.title') }}
                        </div>
                        <div class="card-content">
                            <ul>
                                <li>{{ $t('dap.platform.product.line1') }}</li>
                                <li>{{ $t('dap.platform.product.line2') }}</li>
                                <li>{{ $t('dap.platform.product.line3') }}</li>
                            </ul>
                        </div>
                    </div>
                    <div @mouseover="img2 = true, img0 = false" @mouseleave="img2 = false, img0 = true" class="card">
                        <div class="card-title">
                            <i class="fas fa-users-cog mr-2"></i> {{ $t('dap.platform.tiers.title') }}
                        </div>
                        <div class="card-content">
                            <ul>
                                <li>{{ $t('dap.platform.tiers.line1') }}</li>
                                <li>{{ $t('dap.platform.tiers.line2') }}</li>
                                <li>{{ $t('dap.platform.tiers.line3') }}</li>
                            </ul>
                        </div>
                    </div>
            
                    <div @mouseover="img3 = true, img0 = false" @mouseleave="img3 = false, img0 = true" class="card">
                        <div class="card-title">
                            <i class="fas fa-shopping-cart mr-2"></i> {{ $t('dap.platform.panier.title') }}
                        </div>
                        <div class="card-content">
                            <ul>
                                <li>{{ $t('dap.platform.panier.line1') }}</li>
                                <li>{{ $t('dap.platform.panier.line2') }}</li>
                                <li>{{ $t('dap.platform.panier.line3') }}</li>
                            </ul>
                        </div>
                    </div>
                    <div @mouseover="img4 = true, img0 = false" @mouseleave="img4 = false, img0 = true" class="card">
                        <div class="card-title">
                            <i class="fas fa-file-invoice mr-2"></i> {{ $t('dap.platform.stock.title') }}
                        </div>
                        <div class="card-content">
                            <ul>
                                <li>{{ $t('dap.platform.stock.line1') }}</li>
                                <li>{{ $t('dap.platform.stock.line2') }}</li>
                                <li>{{ $t('dap.platform.stock.line3') }}</li>
                                <li>{{ $t('dap.platform.stock.line4') }}</li>
                            </ul>
                        </div>
                    </div>
                </div>

            <div class="col-md-12  large">
                <img v-show="img0" src="@/assets/img/DAPChart.png" class="img-fluid mb-5" alt="">
                <img v-show="img1" src="@/assets/img/DAPChart1.png" class="img-fluid mb-5" alt="">
                <img v-show="img2" src="@/assets/img/DAPChart2.png" class="img-fluid mb-5" alt="">
                <img v-show="img3" src="@/assets/img/DAPChart3.png" class="img-fluid mb-5" alt="">
                <img v-show="img4" src="@/assets/img/DAPChart4.png" class="img-fluid mb-5" alt="">
            </div>
                
                
            </div>

        </div>
        
        <div class="highlighted mt-5"> {{ $t('dap.verbatimTitle') }} </div>

       
        <div class="row">

            <div class="col-sm-6 mx-auto">
                <div class="card">
                    <div class="mr-auto mb-3"><img class="img-fluid" src="@/assets/img/seveal.png" alt=""></div>
                    <div class="temoignage">
                        « {{ $t('dap.sevealSay1') }} <br>
                        {{ $t('dap.sevealSay2') }} <br>
                        {{ $t('dap.sevealSay3') }} »
                    </div>
                    <div class="client"><span class="clientName">Emmanuel J.</span>, DG SEVEAL UNION</div>
                </div>
            </div>
                
        </div>
            


        

        

        <!-- <div class="container">
            <div class="contact-block text-center m-5">
            <div class="block_title">Compte Démo : Connectez-vous</div>
            <div class="imgContact">
                <div class="form-group">
                    <label class="formLabel"  for="login">Email/login</label>
                    <input  v-model="login" required  type="email" class="form-control" id="txtlogin" aria-describedby="login">
                </div>
                <div class="form-group">
                    <label class="formLabel" for="mdp">Mot de passe</label>
                    <input  v-model="mdp"  type="password" class="form-control" id="txtmdp" aria-describedby="mdp">
                </div>
                <button v-on:click="toDap()" class="form-group btn btn-secondary">Se connecter</button>
                <div class="result" v-bind:class="{ 'text-danger': hasError }">{{ result }}</div>
            </div>
            <router-link class="btn btn-primary mx-auto" to="/contact-demo">Demander un accès </router-link>
            </div>    
        </div> -->



        <div class="highlighted text-center"> {{ $t('dap.clients') }}</div>
            <div class="row clients-logo text-center mb-5">
            <div class="col-lg-4 logoContainer mx-auto"><img class="img-fluid" src="@/assets/img/vivescia.png" alt=""></div>
            <div class="col-lg-4 logoContainer mx-auto"><img class="img-fluid" src="@/assets/img/ceresia.png" alt=""></div>
            <div class="col-lg-4 logoContainer mx-auto"><img class="img-fluid" src="@/assets/img/logo_novagrain.svg" alt=""></div>
            <div class="col-lg-4 logoContainer mx-auto"><img class="img-fluid" src="@/assets/img/seveal.png" alt=""></div>
            <div class="col-lg-4 logoContainer mx-auto"><img class="img-fluid" src="@/assets/img/logo-sepac-compagri.jpg" alt=""></div>
        </div>



        <MailjetNewsLetter/>

    </div>


    
    
</template>

<script>

import MailjetNewsLetter from '../components/MailjetNewsLetter'


export default {
    name: 'Digitappro',
    data(){
      return {
        login: '',
        mdp:'',
        hasError:false,
        result:'',
        img0: true,
        img1: false
      }
    },    
    components:{
            MailjetNewsLetter
        },
    methods:{
         toDap () {
            this.hasError = false
            this.result = ''
            if (!this.login || this.login.trim() === '' || this.mdp.trim() === '' || !this.mdp) {
              this.hasError = true
              this.result = 'Merci de renseigner tous les champs afin de vous connecter'
            } else {
              const jeton = window.btoa(unescape(encodeURIComponent("loginTiers="+this.login+"&password=" + this.mdp)));
              const uri = "https://staging-front.digitappro.io/login?jetonsso="+jeton;
              const encoded = encodeURI(uri);
              window.open(encoded, '_blank');
            }
         }
    }
}
</script>

<style lang="scss" scoped>

  

    .highlighted{
        font-size: 40px!important;
        font-weight: 800;
        margin-top: 140px;
        margin-bottom: 50px;
        display: flex;
        flex-direction: column;
        align-items: center;
        color: var(--mainBlue)!important;
        .blue{
           color: var(--mainGreen);
           font-size: 30px!important;
        }

    }

    p{
        text-align: justify;
    }

    @media (min-width: 768px) {

        .profiledRight{
        // transform: translate(20%, 0px) rotate(-4e-05deg) rotateY(-5deg) rotateX(4deg)!important;
        transform: translate(20%, 0px)!important;
        }
        .profiledLeft{
            // transform: translate(-20%, 0px) rotate(-4e-05deg) rotateY(5deg) rotateX(4deg)!important;
            transform: translate(-20%, 0px) !important;
        }
        .large{
            // transform: translate(-40%, 400px) rotate(-4e-05deg) rotateY(14deg) rotateX(10deg) scale(1.5)!important;
        }
            
    }
    @media (max-width: 768px) {

        .profiledRight{
            margin-top: 50px;
        }   
        .profiledLeft{
            margin-bottom: 50px;
        }
        .image{
            padding: 0px 30px;
        }
            
    }



    

    .decoIcon{
        position: relative;
        height: 20px;
        width: 20px;
        transform: rotate(90deg);
    }

    .titleProduct{
        text-align: left;
        font-weight: 600;
        font-size: 55px;
        color: var(--mainBlue);
        padding-top: 50px;
    }

    .screenShot{
        -webkit-box-shadow: 6px 9px 20px 0px rgba(19, 34, 81, 0.17);
        box-shadow: 6px 9px 20px 0px rgba(19, 34, 81, 0.17);
        border-radius: 20px;
    }

    .featuresList{
        text-align: center;
        font-size: 20px;
        font-weight: 600;
        img{
            padding: 5px;
            margin-bottom: 40px;
        }
    }

    video{
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        -webkit-box-shadow: 6px 9px 20px 0px rgba(19, 34, 81, 0.17);
        box-shadow: 6px 9px 20px 0px rgba(19, 34, 81, 0.17);
        width: 100%;
        margin-top: 50px;
        margin-bottom: 50px;
        &:hover{
            cursor:auto;
        }
    }

    .poductLink{
        background-color: white;
        border: var(--mainBlue) 10px solid;
        border-radius: 20px;
        padding: 30px;
        text-align: center;
    }

     .btn {
        padding: 15px;
        font-weight: 600;
        margin: 20px;
        min-width: 200px;
    }

    .contact-block {
        color: white;
        font-weight: 600;
        font-size: 25px;
        background-color: var(--mainBlue);
        padding: 20px;
        border-radius: 18px;
        text-align: center;
    .tagline{
      padding: 50px 0px 20px 0px;
    }
    .styledInput{
        margin: auto;
        border-radius: 25px;
        max-width: 300px;
        height: 45px;
    }
    .button-input{
        background-color: var(--mainGreen);
        color: white;
        position: relative;
        height: 40px;
        top: -42.5px;
        left: 105px;
        z-index: 20;
        &:hover{
            background-color: var(--mainBlue);
        }
    }
    .form-group{
    
      .formLabel{
          font-size: 16px;
          font-weight: 600;
      }
      .form-text{
          font-size: 13px;
          font-weight: 400;
      }
    }
    
    .block_title {
      color: var(--mainGreen);
      text-align: left;
    }

    
    
    .result {
        font-weight: 600;
        margin-top: 10px;
        color: var(--mainGreen);
    }
    // .imgContact{
    //     background-image: url('../assets/img/contactezNous.png');
    //     background-repeat: no-repeat;
    //     background-position: center;
    //     background-size: cover;
    //     height: 20%;
    // }
  }
  .logoProd {
        max-height: 120px;
    }

    .card {
        border: none;
        border-radius: 10px;
        padding: 15px;
        margin-bottom: 15px;
        -webkit-box-shadow: 6px 9px 20px 0px rgba(19, 34, 81, 0.17);
        box-shadow: 6px 9px 20px 0px rgba(19, 34, 81, 0.17);
        // height: 200px;
        .temoignage{
            font-style: italic;
        }
        .client{
            margin-top: 15px;
            font-size: 13px;
            .clientName{
                font-weight: 600;
                color: var(--mainGreen);
            }
        }
    }
    .card-title{
            font-weight: 700;
            font-size: 16px;
            svg{
                font-size: 25px;
            }
        }
        .icon-title{
            width:40px; 
            height: 40px;
        }


    .chart-btn{
        display: flex;
        align-items: stretch;
        justify-content: space-between;
        .card{
            width: 24%;
            &:hover{
                cursor: pointer;
                background-color: var(--mainGreen);
            }
            ul{
                margin-block-start: 0px;
                padding-inline-start: 15px;
            }
        }
    }


</style>